const JAGROOK_MESSAGE = {
  heading: "SEBI Project Jagrook",
  title: "SEBI presents Samajh Se Investing Simple:",
  points: [
    "Understand Before You Invest",
    "Choose Regulated Investment Products",
    "Start Early, Stay Invested",
    "Beware of Investment Frauds"
  ]
};

const RISK_DISCLOSURES = {
  title: "RISK DISCLOSURES ON DERIVATIVES",
  points: [
    "9 out of 10 individual traders in equity Futures and Options Segment, incurred net losses.",
    "On an average, loss makers registered net trading loss close to ₹ 50,000.",
    "Over and above the net trading losses incurred, loss makers expended an additional 28% of net trading losses as transaction costs.",
    "Those making net trading profits, incurred between 15% to 50% of such profits as transaction cost."
  ],
  source: "SEBI study dated January 25, 2023 on “Analysis of Profit and Loss of Individual Traders dealing in equity Futures and Options (F&O) Segment”, wherein Aggregate Level findings are based on annual Profit/Loss incurred by individual traders in equity F&O during FY 2021-22."
};

const JAGROOK_DAYS = [0, 1, 3, 5];
const RISK_DISCLOSURE_DAYS = [2, 4, 6];

const SHOW_BOTH = false;

const weekday = new Date().getDay();

const SEBI_AWARENESS_DISPLAY = {
  showJagrook: SHOW_BOTH || JAGROOK_DAYS.includes(weekday),
  showRiskDisclosures: SHOW_BOTH || RISK_DISCLOSURE_DAYS.includes(weekday)
};

export {
  JAGROOK_MESSAGE,
  RISK_DISCLOSURES,
  SEBI_AWARENESS_DISPLAY
};
